var video_viewer_default = {
  "video_player": "q417-",
  "videoOverlay": "b483P",
  "video_container": "_2IPIu"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
